import React from 'react'
import '../App.css';
// import { Navbar,Footer} from '../container';
// import Ayuda from '../components/ayuda/Ayuda';
import Comenta from '../container/comentario/comenta/Comenta';
// import Biblioteca from '../container/biblio/biblioteca/Biblioteca';

const SecBibliote = () => {
  return (
    <div class="App_DB">
       
       <Comenta/>
      
</div>
  )
}

export default SecBibliote
